import {ReactElement} from "react";

import {ButtonTypography, ButtonVariant} from "@/components/button/Button.types.ts";
import {ChipVariant} from "@/components/chip/Chip.tsx";

export const NAV_TABS_VARIANTS = ["default", "marketing", "pagespeed", "header", "statuspage", "compact"] as const;

export type NavTabsVariant = (typeof NAV_TABS_VARIANTS)[number];

export const NavTabsButtonVariant: Record<NavTabsVariant, ButtonVariant> = {
  default: "navTabsButton",
  marketing: "navTabsMarketingButton",
  pagespeed: "navTabsPagespeedButton",
  header: "navTabsButton",
  statuspage: "navTabsButton",
  compact: "navTabsButton",
};

export const NavTabsButtonTypography: Record<NavTabsVariant, ButtonTypography[]> = {
  default: ["link", "linkBold"],
  marketing: ["marketingLinkTiny", "marketingLinkTinyBold"],
  pagespeed: ["link", "linkBold"],
  header: ["link", "linkBold"],
  statuspage: ["linkBold", "linkBold"],
  compact: ["link", "linkBold"],
};

export const NavTabsBadgeVariant: Record<NavTabsVariant, ChipVariant[]> = {
  default: ["navTabDisabled", "navTab"],
  marketing: ["navTabDisabled", "navTab"],
  pagespeed: ["navTabDisabled", "navTab"],
  header: ["navTabDisabled", "navTab"],
  statuspage: ["navTabDisabled", "navTab"],
  compact: ["count", "count"],
};

export interface NavTabItem {
  id: string;
  title: string | ReactElement;
  badgeText?: string | number;
  error?: boolean;
}

export interface NavTabsProps {
  className?: string;
  items: NavTabItem[];
  selectedId: string;
  selectTab: (tab: string) => void;
  variant?: NavTabsVariant;
}
